<div class="ignite-swiper-container">
  <div [id]="id" class="ignite-swiper">
    <div
      class="ignite-swiper-cards"
      (mousedown)="swipe($event, 'start')"
      (mouseup)="swipe($event, 'end')"
      (touchstart)="swipe($event, 'start')"
      (touchend)="swipe($event, 'end')"
      #cardsContainer
      >
      <ng-content select="[swiper-card]"></ng-content>
    </div>
  </div>
  @if (pages.length > 1) {
    <div class="ignite-swiper-indicators">
      @for (p of pages; track p; let i = $index) {
        <i class="fas fa-circle" [class.selected]="i === currentIdx" (click)="selectCard(i)"></i>
      }
    </div>
  }
  @if (pages.length > 1 && currentIdx > 0) {
    <i class="fas fa-chevron-circle-left ignite-swiper-arrow" (click)="selectPrevious()"></i>
  }
  @if (pages.length > 1 && currentIdx < pages.length - 1) {
    <i class="fas fa-chevron-circle-right ignite-swiper-arrow" (click)="selectNext()"></i>
  }
</div>
